import React from "react";
import {useDispatch, useSelector} from 'react-redux';
import styles from "../login_page.module.scss";
import {Alert} from "react-bootstrap";
import {dismiss_success} from "../../_redux/_actions/authentication.actions";

const SuccessMessage = () => {
  const dispatch = useDispatch();
  const {successMessage} = useSelector(state => state.authentication);
  return ( successMessage &&
    <Alert onClose={() => dispatch(dismiss_success())} variant="success" className={styles.alertMessage} dismissible>
      <Alert.Heading className={"m-2"}>Success!</Alert.Heading>
      <p className={"m-2"}>
        {successMessage}
      </p>
    </Alert>
  );
}

export default SuccessMessage;